// Whether this page is running inside the Twine iOS / Android app.
// Seeded on the server from the request user agent (see serverRenderer.js)
// and hydrated on the client, so SSR and first client render agree.
const SET_PLATFORM = 'twineApp/nativeApp/SET_PLATFORM';

const initialState = {
  platform: null,
};

export default function reducer(state = initialState, action = {}) {
  if (action.type === SET_PLATFORM) {
    return {
      ...state,
      platform: action.platform || null,
    };
  }

  return state;
}

export function setNativePlatform(platform) {
  return {
    type: SET_PLATFORM,
    platform,
  };
}

export function isNativeApp(globalState) {
  return Boolean(globalState.nativeApp && globalState.nativeApp.platform);
}

export function getNativePlatform(globalState) {
  return (globalState.nativeApp && globalState.nativeApp.platform) || null;
}
